<template>
  <v-container id="meeting-list">
    <v-row>
      <v-col>
        <app-city-combobox :filter="filter"></app-city-combobox>
      </v-col>

      <v-col
        v-if="
          isFullAdmin ||
          (config.visualizaTodosEncontros &&
            groupsConfig.visualizaTodosEncontros)
        "
      >
        <app-consultant-combobox :filter="filter"></app-consultant-combobox>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataInicialString"
          v-mask="'##/##/####'"
          label="Data Inicial"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataFinalString"
          v-mask="'##/##/####'"
          label="Data Final"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="getMeetings()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.temRelatorio="{ item }">
            <span v-if="item.temRelatorio"> Sim </span>
            <span v-if="!item.temRelatorio"> Não </span>
          </template>
          <template v-slot:item.exclusao="{ item }">
            <app-modal-delete
              v-if="
                (isFullAdmin ||
                  (config.podeExcluirEncontro &&
                    groupsConfig.podeExcluirEncontro)) &&
                !item.temRelatorio
              "
              :relatorio="item"
              @onDelete="getMeetings"
            >
              <template v-slot:title>
                Deletar {{ isAT ? "agenda" : "encontro" }}
              </template>
            </app-modal-delete>
          </template>
          <template slot="no-data">
            <span>
              {{
                isAT ? "Nenhuma agenda retornada" : "Nenhum encontro retornado"
              }}
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { meetingAPI } from "@/modules/calendar";
import { mapActions, mapGetters } from "vuex";
import { AppConsultantCombobox } from "@/modules/user";
import { AppCityCombobox } from "@/modules/city";
import AppModalDelete from "./../components/ModalDelete";

export default {
  components: {
    AppCityCombobox,
    AppConsultantCombobox,
    AppModalDelete,
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "user",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isAT",
      "isFullAdmin",
      "isGov",
    ]),
  },
  data() {
    return {
      headers: [
        { text: "Id do encontro", value: "encontroId" },
        { text: "Título", value: "nome" },
        { text: "Criado por", value: "usuario.nome" },
        { text: "Município", value: "municipio.nome" },
        { text: "Início", value: "inicioString" },
        { text: "Fim", value: "fimString" },
        { text: "Tem relatório", value: "temRelatorio" },
        { text: "Ação", value: "exclusao" },
      ],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      userTeste: JSON.parse(localStorage.getItem("user")),

      payload: [],
      filter: {},
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    getMeetings() {
      this.setLoading(true);
      if (
        !this.isFullAdmin &&
        !this.config.visualizaTodosEncontros &&
        !this.groupsConfig.visualizaTodosEncontros
      ) {
        this.filter.usuarioId = this.user.usuarioId;
      }

      meetingAPI
        .getByFilter(this.filter)
        .then((resp) => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao obter ${isAT ? "agendas" : "encontros"}`
          );
        });
    },
  },
  mounted() {
    if (this.isAT)
      this.headers = [
        { text: "Id da agenda", value: "encontroId" },
        { text: "Título", value: "nome" },
        { text: "Criado por", value: "usuario.nome" },
        { text: "Município", value: "municipio.nome" },
        { text: "Início", value: "inicioString" },
        { text: "Fim", value: "fimString" },
        { text: "Tem relatório", value: "temRelatorio" },
        { text: "Ação", value: "exclusao" },
      ];

    if (this.isGov) {
      this.headers = [
        { text: "Id do encontro", value: "encontroId" },
        { text: "Título", value: "nome" },
        { text: "Criado por", value: "usuario.nome" },
        { text: "Projeto", value: "municipio.nome" },
        { text: "Início", value: "inicioString" },
        { text: "Fim", value: "fimString" },
        { text: "Tem relatório", value: "temRelatorio" },
        { text: "Ação", value: "exclusao" },
      ];
    }
    //  this.getMeetings()
  },
};
</script>
